import logo from "../../assets/images/logo/Logo_Carpe_Diem.png";

const LegalNotice = () => {
  document.title = "Carpe Diem - Mentions légales & CGU";
  return (
    <main className="mainLegales">
      <section className="sectionLegale">
        <div className="retourFleche">
          <p>
            <a className="retour" href="/">
              <span className="returnHome">{"<"}</span> Retour
            </a>
          </p>
        </div>
        <div className="containLogo">
          <a className="navbar-brand" href="/">
            <img src={logo} className="logo_mentions" alt="logo Carpe Diem" />
          </a>
        </div>
        <div className="divLegales">
          <h1 className="h1Mentions">📜 Mentions Légales</h1>
          <section className="legalNotice">
            <div id="editor" className="sectionMention">
              <h2 className="h2Mentions">Propriétaire du site</h2>
              <div className="pMentions">
                <p>
                  Nom du restaurant : <strong>Carpe Diem</strong>
                </p>
                <p>
                  Forme juridique :{" "}
                  <strong>[Ex : SARL, Auto-entreprise]</strong>
                </p>
                <p>
                  Numéro SIRET / SIREN : <strong>[Numéro Carpe Diem]</strong>
                </p>
                <p>
                  Adresse : <strong>[Adresse Carpe Diem]</strong>
                </p>
                <p>
                  Email :{" "}
                  <a
                    href="mailto:[email Carpe Diem]"
                    className="linkContact linkMention"
                  >
                    [email Carpe Diem]
                  </a>
                </p>
                <p>
                  Téléphone :{" "}
                  <a
                    className="linkContact linkMention"
                    href="tel:[téléphone Carpe Diem]"
                  >
                    [téléphone Carpe Diem]
                  </a>
                </p>
              </div>
            </div>
            <div id="editor" className="sectionMention">
              <h2 className="h2Mentions">Conception & développement</h2>
              <div className="pMentions">
                <p>
                  Site réalisé par : <strong>Dev'Alls</strong>
                </p>
                <p>
                  SIRET : <strong>939 239 653</strong>
                </p>
                <p>
                  Adresse :{" "}
                  <strong>
                    7 Résidence des fougères, 76560 Héricourt-En-Caux
                  </strong>
                </p>
                <p>
                  Email :{" "}
                  <a
                    href="mailto:contact.devalls@gmail.com"
                    className="linkContact linkMention"
                  >
                    contact.devalls@gmail.com
                  </a>
                </p>
                <p>
                  Site Web :{" "}
                  <a
                    href="https://www.devalls.fr"
                    className="linkContact linkMention"
                  >
                    https://www.devalls.fr
                  </a>
                </p>
                <p>
                  Téléphone :{" "}
                  <a
                    className="linkContact linkMention"
                    href="tel:+33770349718"
                  >
                    07 70 34 97 18
                  </a>
                </p>
              </div>
            </div>
            <div id="hebergement" className="sectionMention">
              <h2 className="h2Mentions">Hébergement</h2>
              <div className="pMentions">
                <p>
                  <strong>Frontend :</strong> Vercel
                </p>
                <p>Adresse : 340 S Lemon Ave #4133, Walnut, CA 91789, USA</p>
                <p>
                  Site web :{" "}
                  <a
                    href="https://vercel.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkContact linkMention"
                  >
                    https://vercel.com
                  </a>
                </p>
                <p>
                  <strong>Backend :</strong> MongoDB Atlas
                </p>
                <p>Adresse : 350 5th Ave, New York, NY 10118, USA</p>
                <p>
                  Site web :{" "}
                  <a
                    href="https://www.mongodb.com/atlas"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkContact linkMention"
                  >
                    https://www.mongodb.com/atlas
                  </a>
                </p>
                <p>
                  <strong>Nom de domaine :</strong> IONOS
                </p>
                <p>Adresse : 7 place de la Gare, 57200 Sarreguemines, France</p>
                <p>
                  Site web :{" "}
                  <a
                    href="https://www.ionos.fr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkContact linkMention"
                  >
                    https://www.ionos.fr
                  </a>
                </p>
              </div>
            </div>
            <div id="propriety" className="sectionMention">
              <h2 className="h2Mentions">Propriété intellectuelle</h2>
              <div className="pMentions">
                <p className="proprietyP">
                  L’ensemble des contenus présents sur ce site (textes, images,
                  logos, code source, design) est protégé par le droit d’auteur
                  et la propriété intellectuelle. Toute reproduction,
                  distribution ou modification sans autorisation préalable est
                  interdite.
                </p>
              </div>
            </div>
            <div id="responsability" className="sectionMention">
              <h2 className="h2Mentions">Responsabilité</h2>
              <div className="pMentions">
                <p className="proprietyP">
                  Carpe Diem et Dev'Alls mettent tout en œuvre pour assurer
                  l’exactitude et la mise à jour des informations présentes sur
                  ce site. Cependant, ils ne peuvent être tenus responsables
                  d’éventuelles erreurs, interruptions ou dommages résultant de
                  l’utilisation du site.
                </p>
              </div>
              <div id="data" className="sectionMention">
                <h2 className="h2Mentions">Données personnelles & Cookies</h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    Carpe Diem collecte certaines données personnelles via des
                    formulaires (contact, réservation…). Ces données ne sont
                    jamais revendues et sont uniquement utilisées dans le cadre
                    de la relation client. Le site utilise des cookies pour
                    améliorer l’expérience utilisateur. Vous pouvez gérer vos
                    préférences via notre{" "}
                    <a
                      className="linkContact linkMention"
                      href="/privacypolicy"
                    >
                      Politique de Confidentialité
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="divLegales">
          <h1 className="h1Mentions">
            📑 Conditions Générales d’Utilisation (CGU)
          </h1>
          <section className="legalNotice">
            <div id="editor" className="sectionMention">
              <h2 className="h2Mentions">1. Objet</h2>
              <div className="pMentions">
                <p>
                  Les présentes Conditions Générales d’Utilisation ont pour
                  objet de définir les règles d’accès et d’utilisation du site
                  Carpe Diem ainsi que les droits et responsabilités de
                  l’éditeur et des utilisateurs.
                </p>
              </div>
            </div>
            <div id="object" className="sectionMention">
              <h2 className="h2Mentions">2. Accès au site et aux services</h2>
              <div className="pMentions">
                <p>
                  Le site est accessible gratuitement à tout utilisateur
                  disposant d’un accès à Internet. Carpe Diem propose des
                  services de restauration, chambres d’hôtes et réservation en
                  ligne pour les particuliers et les professionnels.
                </p>
              </div>
            </div>
            <div id="accesWeb" className="sectionMention">
              <h2 className="h2Mentions">3. Responsabilités</h2>
              <div className="pMentions">
                <p className="proprietyP">
                  L’utilisateur s’engage à utiliser le site conformément aux
                  lois en vigueur. Carpe Diem et Dev'Alls ne pourront être tenus
                  responsables en cas de :
                </p>
                <ul className="ulMentions">
                  <li>
                    - Problèmes techniques entraînant l’interruption du site.
                  </li>
                  <li>
                    - Contenus extérieurs accessibles via des liens hypertextes.
                  </li>
                  <li>- Mauvaise utilisation du site par l’utilisateur.</li>
                </ul>
              </div>
            </div>
            <div id="responsability" className="sectionMention">
              <h2 className="h2Mentions">4. Propriété intellectuelle</h2>
              <div className="pMentions">
                <p className="proprietyP">
                  Les éléments du site (contenus, images, logos, codes) restent
                  la propriété exclusive de Carpe Diem et Dev'Alls. Toute
                  reproduction, modification ou diffusion sans autorisation est
                  interdite.
                </p>
              </div>
              <div id="property" className="sectionMention">
                <h2 className="h2Mentions">
                  5. Protection des données personnelles
                </h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    Conformément au RGPD, l’utilisateur dispose d’un droit
                    d’accès, de rectification et de suppression de ses données
                    personnelles en écrivant à{" "}
                    <a
                      className="linkContact linkMention"
                      href="mailto:[email Carpe Diem]"
                    >
                      [email Carpe Diem]
                    </a>
                    .
                  </p>
                </div>
              </div>
              <div id="modify" className="sectionMention">
                <h2 className="h2Mentions">6. Modification des CGU</h2>
                <div className="pMentions">
                  <p className="proprietyP">
                    Carpe Diem et Dev'Alls se réservent le droit de modifier les
                    présentes CGU à tout moment. Les utilisateurs sont invités à
                    les consulter régulièrement.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default LegalNotice;
